import { useAuthStore } from "../../../global-account/react/index.js";
import { debugB3React } from "../../../shared/utils/debug.js";
import { client } from "../../../shared/utils/thirdweb.js";
import { useEffect, useMemo, useState } from "react";
import { viemAdapter } from "thirdweb/adapters/viem";
import { useConnectedWallets, useWalletInfo } from "thirdweb/react";
const debug = debugB3React("useFirstEOA");
export function useFirstEOA(chain) {
  const wallets = useConnectedWallets();
  const isConnected = useAuthStore(state => state.isConnected);
  const [firstEOA, setFirstEOA] = useState(undefined);
  const [address, setAddress] = useState(undefined);
  const walletInfo = useWalletInfo(firstEOA?.id);
  debug("Wallets", wallets);
  debug("Is connected", isConnected);
  useEffect(() => {
    const autoSelectFirstEOAWallet = async () => {
      // Only proceed if auto-selection is enabled and user is authenticated
      if (!isConnected) {
        debug("Not connected");
        return;
      }
      // Find the first EOA wallet (excluding ecosystem wallets)
      const isEOAWallet = wallet => !wallet.id.startsWith("ecosystem.");
      const firstEOAWallet = wallets.find(isEOAWallet);
      debug("First EOA wallet", firstEOAWallet);
      const account = firstEOAWallet?.getAccount();
      debug("Account", account);
      setFirstEOA(firstEOAWallet);
      debug("Address", account?.address);
      setAddress(account?.address);
    };
    autoSelectFirstEOAWallet();
  }, [isConnected, wallets]);
  const walletClient = useMemo(() => {
    if (!firstEOA) return undefined;
    if (!chain) return undefined;
    try {
      const viemClientWallet = viemAdapter.wallet.toViem({
        client,
        chain,
        wallet: firstEOA
      });
      return viemClientWallet;
    } catch (err) {
      console.error("Error setting wallet client", err);
    }
  }, [firstEOA, chain]);
  return {
    account: firstEOA,
    address,
    info: walletInfo,
    walletClient
  };
}